// @flow
import actorItems from './actorItems';
import actorActivity from './actorActivity';


const filterId: 'actor' = 'actor';
export default filterId;
export { actorItems, actorActivity };
